<template>
  <sa-page-layout :btnRefreshVisible="btnRefreshVisible" :btnNewVisible="btnNewVisible" :linkedit="linkedit"
    @refresh="onRefresh" :showModalLoading="showModalLoading">
    <template slot="table-filter">
      <b-form @submit.prevent="onSubmit">
        <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
          <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
            <label class="sa-label-data">Presidio Associato:</label>
            <b-form-select id="inline-form-custom-select-pref" v-model="filtroAgenda.idPresidio"
              class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="codicePresidio" text-field="denominazionePresidio"
              :options="presidiOptions" required>
              <template #first>
                <b-form-select-option :value="null">TUTTI</b-form-select-option>
              </template>


            </b-form-select>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
            <label class="sa-label-data">Titolo:</label>
            <b-form-input v-model="filtroAgenda.titolo" type="search" placeholder="Titolo"></b-form-input>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
            <label class="sa-label-data">Descrizione:</label>
            <b-form-input v-model="filtroAgenda.descrizione" type="search" placeholder="Descrizione"></b-form-input>
          </b-col>
        </b-row>
        <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
          <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right text-right">
            <b-button type="submit" @click="loadData()" variant="info">Cerca</b-button>
            <b-button type="reset" v-on:click="onReset" variant="danger">Reset</b-button>
          </b-col>
        </b-row>
      </b-form>
    </template>
    <template slot="table-body">
      <agende-list-component @delete="onDeleteAgenda" :utente="utente"
        ref="cmpAgendeListComponent"></agende-list-component>
    </template>
  </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import AgendeListComponent from "../components/AgendeListComponent.vue";
import PresidiMixin from "../../strutture/mixins/PresidiMixin";
export default {
  mixins: [PresidiMixin],
  props: {
    utente: { type: Object },
  },
  components: { SaPageLayout, AgendeListComponent },
  mounted() {
    this.loadUtentePresidio();
    this.loadData();

  },
  data() {
    return {
      btnRefreshVisible: true,
      btnNewVisible: true,
      linkedit: "/agende",
      showModalLoading: false,
      filtroAgenda: { titolo: null, descrizione: null, idPresidio: null },
    };
  },
  methods: {
    loadData() {
      let me = this;
      let sessionStorage = window.sessionStorage;
      if (sessionStorage["filtroAgende"]) {
        me.filtroAgenda = JSON.parse(sessionStorage["filtroAgende"]);
      }

      me.$refs.cmpAgendeListComponent.loadData(me.filtroAgenda);
    },
    onRefresh() {
      this.loadUtentePresidio();
      this.loadData();
    },
    onDeleteAgenda() {
      this.loadData();
    },
    onSubmit() { },
    onReset() { },
    loadUtentePresidio() {
      let me = this;
      let sessionStorage = window.sessionStorage;
      if (sessionStorage.getItem("user")) {
        let user = JSON.parse(sessionStorage.getItem("user"));
        me.loadPresidiUtente(user.id, me.loadPresidiUtenteSuccess);
      }
    },
    loadPresidiUtenteSuccess(re) {
      console.log("ok", re);

    },
  },
};
</script>

<style></style>
